<template>
  <main>
    <div class="py-4 container-fluid">
      <GridRow>
        <GridCol :size="12">
          <MetaSection title="Detail Penilaian Kinerja">
            <div class="text-right">
              <!-- <div class="d-flex flex-row gap-3">
                <argon-button :outline="true">Kembali</argon-button>
                <argon-button>Kirim</argon-button>
              </div> -->

              <div class="d-flex gap-3">
                <router-link :to="{ name: 'Penilaian Kinerja' }">
                  <button class="btn btn-secondary">
                    Kembali
                  </button>
                </router-link>
              </div>
            </div>
          </MetaSection>
        </GridCol>
        <GridCol :size="12">
            <cards title="Form Realisasi KPI" :withmin="false">
              <h5>Informasi Umum</h5>
              <div class="d-flex gap-4 mt-2">
                <!-- <div class="bg-secondary rounded-2 p-0" style="width: 92px !important; height: 92px !important; "></div> -->
                
                <div class="d-flex flex-column gap-3 w-100">
                  <div class="row ">
                    <div class="col d-flex flex-column">
                      <span class="text-secondary text-xs">Nama Penilaian Kinerja</span>
                      <span>{{ detail_data?.title || '-' }}</span>
                    </div>
                    <div class="col d-flex flex-column">
                      <span class="text-secondary text-xs">Unit Kerja</span>
                      <span>{{ detail_data?.unitkerja || '-' }}</span>
                    </div>
                    <div class="col d-flex flex-column">
                      <span class="text-secondary text-xs">Jabatan</span>
                      <span>{{ detail_data?.jabatan || '-' }}</span>
                    </div>
                  </div>
                  
                  <div class="row">
                    <div class="col d-flex flex-column">
                      <span class="text-secondary text-xs">Status</span>
                      <span>{{ detail_data?.status ? (detail_data?.status === 'active' ? 'Aktif' : 'Non Aktif') : '-' }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </cards>
        </GridCol>
        <GridCol :size="12" class="mt-4">
          <cards title="Form Realisasi KPI" :p="0" class="card--tabs">
            <div class="mb-2 d-flex items-center justify-content-between flex-column gap-4 pb-4">
              <h5>Aspek Penilaian Kinerja</h5>
            </div>

            <!-- <pre>{{ detail_data }}</pre> -->
            <template v-if="detail_data?.kpi?.length > 0">
              <form-group
                v-for="(item,index) in detail_data.kpi"
                :key="index"
                :label="item?.title || '-'"
              >
                <!-- :hint="item?.sub_jumlah || item?.sub_jumlah === 0 ? item?.sub_jumlah : (sumBobotSubKpi(item?.sub_kpi || []))" -->
                <div class="table-responsive">
                  <table class="table align-middle border border-1 border-light">
                    <thead class="table-light">
                      <tr>
                        <th style="min-width: 280px;">Sub KPI</th>
                        <th>Target</th>
                        <th>Satuan</th>
                        <th>Bobot</th>
                        <th>Realisasi</th>
                        <!-- <template v-if="employee_id_login === employee?.immediate_supervisor_id || employee_id_login === employee?.leader_id">
                          <th>Nilai</th>
                          <th>Pencapaian</th>
                        </template> -->
                        <!-- <th>Total Bobot</th>
                        <th>Rata-rata</th> -->
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(sub, i) in item?.child"
                        :key="i"
                        class="border border-bottom-1 border-light"
                      >
                        <td>
                          <p>{{ sub?.title || '-' }}</p>
                          <!-- <p v-if="sub?.catatan" class="text-xs"> {{ sub?.catatan || '-' }}</p> -->
                        </td>
                        <td width="150">
                          <p>
                            <span v-if="sub?.satuan?.toLowerCase() === 'rupiah'">
                              {{
                                new Intl.NumberFormat('id-ID', {
                                  style: 'currency',
                                  currency: 'IDR',
                                  minimumFractionDigits: 0,
                                }).format(sub?.target || '0')
                              }}
                            </span>
                            <span v-else>
                              {{
                                new Intl.NumberFormat('id-ID', {
                                  minimumFractionDigits: 0,
                                }).format(sub?.target || '0')
                              }} 
                              <span class="text-capitalize">{{ (sub?.satuan?.toLowerCase() === 'persen' ? '%' : sub?.satuan) || '' }}</span>
                            </span>
                          </p>
                        </td>
                        <td width="100">
                          <p>
                            <span class="badge badge-secondary w-100">{{ sub?.satuan || '-' }}</span>
                          </p>
                        </td>
                        <td width="100">
                          <p class="text-center">{{ sub?.bobot || sub?.bobot === 0 ? sub.bobot +'%' : '-' }}</p>
                        </td>
                        <td width="150">
                          <p>
                            <span v-if="sub?.satuan?.toLowerCase() === 'rupiah'">
                              {{
                                new Intl.NumberFormat('id-ID', {
                                  style: 'currency',
                                  currency: 'IDR',
                                  minimumFractionDigits: 0,
                                }).format(sub?.realisasi || '0')
                              }}
                            </span>
                            <span v-else>
                              {{
                                new Intl.NumberFormat('id-ID', {
                                  minimumFractionDigits: 0,
                                }).format(sub?.realisasi || '0')
                              }} 
                              <span class="text-capitalize">{{ (sub?.satuan?.toLowerCase() === 'persen' ? '%' : sub?.satuan) || '' }}</span>
                            </span>
                          </p>
                        </td>
                        <!-- <template v-if="employee_id_login === employee?.immediate_supervisor_id || employee_id_login === employee?.leader_id">
                          <td width="100">
                            <p>{{ sub?.nilai || sub?.nilai === 0 ? sub.nilai : '-' }}</p>
                          </td>
                          <td width="100">
                            <p>{{ sub?.pencapaian ? sub.pencapaian +'%' : '-' }}</p>
                          </td>
                        </template> -->
                      </tr>
                    </tbody>
                  </table>
                </div>
              </form-group>
            </template>
          </cards>
        </GridCol>
      </GridRow>
    </div>
  </main>
</template>
    
<script>
import Cards from "@/components/CardComponent.vue";
import FormGroup from "@/components/FormGroup.vue";
import MetaSection from '@/components/MetaSection.vue';
import GridRow from "@/components/grid/GridRow.vue";
import GridCol from "@/components/grid/GridCol.vue";

// import EmployeeApi from "@/repository/api/EmployeeApi";
// import KpiPeriodeApi from "@/repository/api/KpiPeriodeApi";
import KpiApi from '@/repository/api/KpiApi';

export default {
  name: "realisasi-target",
  components: {
    // FieldsetComponent,
    FormGroup,
    Cards,
    // TabbedPane,
    // ArgonButton,
    MetaSection,
    GridRow,
    GridCol,
    // InputForm,
    // ArgonAlert,
  },
  data() {
    return {
      detail_data: {}
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
  },
  watch: {
    // 
  },
  methods: {
    // sumBobotSubKpi(data) {
    //   data = data.map((item) => parseFloat(item?.bobot || 0));
    //   data = data.reduce((a, b) => a + b, 0);
    //   return data;
    // },
    // sumNilaiPenugasan(data) {
    //   data = data.map((item) => parseFloat(item?.nilai || 0));
    //   data = data.reduce((a, b) => a + b, 0);
    //   return data;
    // },

    // async getKpiPeriode() {
    //   console.log('this.periode_id', this.periode_id)
    //   await KpiPeriodeApi.get(this.periode_id)
    //     .then((response) => {
    //       this.periode_active = response?.data || {};
    //     })
    //     .catch((err) => {
    //       console.log(err)
    //     });
    // },
    // async getEmployee() {
    //   await EmployeeApi.get(this.employee_id)
    //     .then((resp) => {
    //       this.employee = resp?.data;
    //     })
    //     .catch((err) => {
    //       console.log(err)
    //     });
      
    //   await this.getSessionUser();
    //   console.log(this.$store.state?.sessionUser);
    //   console.log('\nthis.employee');
    //   console.log(this.employee);
    //   this.employee_id_login = this.$store.state?.sessionUser?.employee?.id || '';
    // },
    async getDetail() {
      console.log(this.$route.params.id)
      this.$store.state.loading = true;
      let params = {
        id: this.id
      }
      // Object.keys(this.params).forEach(key => {
      //   if (!(this.params[key] === undefined || this.params[key] === null || this.params[key] === "")) {
      //     params[key] = JSON.parse(JSON.stringify(this.params[key]))
      //   }
      // });
      await KpiApi.getByParamsNew(params)
        .then((res) => {
          const data = res?.data

          if (data?.[0]) {
            this.detail_data = data?.[0]
          }

        }).catch((error) => {
          console.log(error)
          this.detail_data = {}
        });
      this.$store.state.loading = false;
    },
  },
  async mounted() {
    this.getDetail();
  },
};
</script>
    